var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50326_23752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3735 11.375H13.457C13.112 11.375 12.832 11.095 12.832 10.75C12.832 10.405 13.112 10.125 13.457 10.125H21.3735C21.7185 10.125 21.9985 10.405 21.9985 10.75C21.9985 11.095 21.7185 11.375 21.3735 11.375Z",
    fill: "#9DA2AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2498 14.5003C18.0898 14.5003 17.9299 14.4394 17.8081 14.317C17.564 14.0727 17.564 13.6769 17.8081 13.4328L20.4914 10.7496L17.8081 8.0663C17.564 7.82217 17.564 7.42637 17.8081 7.18224C18.0524 6.93795 18.4482 6.93795 18.6923 7.18224L21.8172 10.3071C22.0614 10.5513 22.0614 10.9471 21.8172 11.1912L18.6923 14.3161C18.5698 14.4394 18.4099 14.5003 18.2498 14.5003Z",
    fill: "#9DA2AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66651 22.0004C8.48814 22.0004 8.31892 21.9753 8.14986 21.9228L3.13491 20.2521C2.45256 20.0137 2 19.3779 2 18.6672V3.66764C2 2.74848 2.7475 2.00098 3.66667 2.00098C3.84488 2.00098 4.0141 2.026 4.18331 2.07849L9.19811 3.74927C9.88061 3.98761 10.333 4.62342 10.333 5.33415V20.3337C10.333 21.2528 9.58567 22.0004 8.66651 22.0004ZM3.66667 3.25094C3.43749 3.25094 3.24996 3.43846 3.24996 3.66764V18.6672C3.24996 18.8446 3.36913 19.0096 3.53911 19.0688L8.53056 20.7321C8.56641 20.7437 8.6131 20.7504 8.66651 20.7504C8.89569 20.7504 9.08306 20.5629 9.08306 20.3337V5.33415C9.08306 5.1567 8.96389 4.99176 8.79392 4.93256L3.80246 3.26925C3.76661 3.25765 3.71992 3.25094 3.66667 3.25094Z",
    fill: "#9DA2AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7072 8.66749C14.3622 8.66749 14.0822 8.3875 14.0822 8.04251V4.29262C14.0822 3.71845 13.6149 3.25094 13.0407 3.25094H3.666C3.32101 3.25094 3.04102 2.97095 3.04102 2.62596C3.04102 2.28097 3.32101 2.00098 3.666 2.00098H13.0407C14.3049 2.00098 15.3322 3.02847 15.3322 4.29262V8.04251C15.3322 8.3875 15.0522 8.66749 14.7072 8.66749Z",
    fill: "#9DA2AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0423 19.5005H9.70896C9.36397 19.5005 9.08398 19.2205 9.08398 18.8755C9.08398 18.5305 9.36397 18.2505 9.70896 18.2505H13.0423C13.6165 18.2505 14.0838 17.783 14.0838 17.2088V13.459C14.0838 13.114 14.3638 12.834 14.7088 12.834C15.0538 12.834 15.3338 13.114 15.3338 13.459V17.2088C15.3338 18.473 14.3064 19.5005 13.0423 19.5005Z",
    fill: "#9DA2AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50326_23752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3cfecd7967ffbbb20d6cdb03fa5f88b4.svg";
export { ForwardRef as ReactComponent };